export default {
  methods: {
    async getYotpoTotalReviewsAndScore () {
      const clientId = this.$config.yotpoClientId
      try {
        const { response: { bottomline } } = await this.$axios.$get(`https://api.yotpo.com/products/${clientId}/yotpo_site_reviews/bottomline`)
        return bottomline
      } catch (e) {
        return 0
      }
    }
  }
}
